import { useMemo } from 'react';

import { MuiDatePickerAdapter } from '../MuiDatePickerAdapter';

import type { DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import type { Dayjs } from 'dayjs';
import type { FC } from 'react';
import type { ControllerFieldState, ControllerProps } from 'react-hook-form';

interface MuiDatePickerAdapterProps
  extends Partial<Omit<Parameters<ControllerProps['render']>[0], 'children'>>
{
  children: React.ReactElement<DatePickerProps<string>>;
  isExposingTextField?: boolean;
  template?: Parameters<Dayjs['format']>[0];
  // valueConverter?: (value: unknown) => string | null;
}

export const MuiDatePickerFieldArrayAdapter: FC<MuiDatePickerAdapterProps> = ({
  children,
  field,
  fieldState,
  formState,
  isExposingTextField = true,
  template,
  ...props
}) => {
  const [, , fieldName] = field?.name.split( '.' ) ?? ['', '', ''];

  const newFieldState: ControllerFieldState | undefined = useMemo(
    () => (fieldState && fieldState.error
      ? {
        ...fieldState,
        error: {
          ...fieldState.error,
          ...fieldState.error[fieldName] ?? {},
        },
      }
      : fieldState),
    [fieldState, fieldName]
  );

  if (!field) return null;

  return (
    <MuiDatePickerAdapter
      children={children}
      field={field}
      fieldState={newFieldState}
      formState={formState}
      isExposingTextField={isExposingTextField}
      template={template}
    />
  );
};
